import {styled} from "@mui/material/styles"
import {Box} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"

export type ShoppingBagContainerProps = {
    isBadgeIcon: boolean
}

export const Container = styled("div")<ShoppingBagContainerProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        margin-right: ${({isBadgeIcon}) => (isBadgeIcon ? "0.5rem" : "0")};
    }

    width: 2.75rem;
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ToolTipContent = styled("div")`
    background: ${({theme}) => theme.uxfabric.background.paper};
    border-radius: ${({theme}) => theme.uxfabric.shape.global.popover.default.borderRadius};
`
export const StyledBox = styled(Box)`
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`
